module.exports = __webpack_public_path__ + "img/vip-mobile-4.4fc164af.jpeg";